<template>
  <div>
    <div class="section-chart">
      <div class="container">
        <div class="div-flex">
          <div class="col-left">
            <label>PRIZE</label>
          </div>
          <div class="col-right txt-right">
            <select v-model="selectedCategory">
              <option
                v-for="(category, cat) of categories"
                :key="cat"
                :value="category.value"
              >
                {{ category.label }}
              </option>
            </select>
          </div>
        </div>
        <!--tabs start-->
        <div class="tab-chart-wrpr">
          <div class="container" style="padding: 0px">
            <div class="tab-chart">
              <button
                v-for="(heading, h) of categoryWinners"
                :key="h"
                :class="h === 0 ? ' active tablinks-btn' : 'tablinks-btn'"
                @click="openChart($event, convertToSlug(heading.heading))"
              >
                {{ heading.heading }}
              </button>
            </div>

            <div
              v-for="(winners, w) of categoryWinners"
              :id="convertToSlug(winners.heading)"
              :key="w"
              :class="w === 0 ? ' block' : ''"
              class="tab-chartcontent"
            >
              <div class="chart-bar-wrpr">
                <div
                  class="bar-position-2"
                  :class="
                    topThreeWinners(winners.winners)[2] ? '' : 'disable-bar'
                  "
                >
                  <p class="prize">{{ topThreeWinners(winners.winners)[2] }}</p>
                  <h1>2<span>nd</span></h1>
                </div>
                <div
                  class="bar-position-1"
                  :class="
                    topThreeWinners(winners.winners)[1] ? '' : 'disable-bar'
                  "
                >
                  <p class="prize">{{ topThreeWinners(winners.winners)[1] }}</p>
                  <h1>1<span>st</span></h1>
                </div>
                <div
                  class="bar-position-3"
                  :class="
                    topThreeWinners(winners.winners)[3] ? '' : 'disable-bar'
                  "
                >
                  <p class="prize">{{ topThreeWinners(winners.winners)[3] }}</p>
                  <h1>3<span>rd</span></h1>
                </div>
              </div>
              <div class="list-prize">
                <ul>
                  <li
                    v-for="(rWinner, rw) in remainingWinners(winners.winners)"
                    :key="rw"
                  >
                    <span class="num"
                      >{{ rw.replace("winner_", "") }}
                      <div class="pos-number">th</div></span
                    ><span class="money">{{ rWinner }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!--tabs end-->
      </div>
    </div>
    <EventLinks :links="getLinks" :new_version="true" v-if="showLink" />
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/commonMixin";
import EventLinks from "@/components/event/EventLinks";

export default {
  name: "PriceWidget",
  components: { EventLinks },
  props: ["winners", "eventData", "showLink"],
  mixins: [commonMixin],

  data() {
    return {
      categories: [],
      firstCategory: "general",
      selectedCategory: "general",
    };
  },
  computed: {
    categoryWinners() {
      const prizeData = this.eventData?.event_prize_money;
      const categoryData = prizeData?.categories?.[this.selectedCategory];

      if (!prizeData || !categoryData || !Array.isArray(prizeData.headings))
        return [];

      const currency = prizeData.currency || "AED";
      const conversionRate = prizeData.conversionRate || 1;
      const isUSD = currency === "USD";

      const data = [];

      // 👇 Loop in exact order of headings[]
      prizeData.headings.forEach(({ gateType, heading }) => {
        const gateData = categoryData[gateType];

        if (!gateData?.prizes?.length) return;

        const winnerData = {};

        gateData.prizes.forEach((prize, index) => {
          let formattedPrize = isUSD ? prize / conversionRate : prize;
          formattedPrize = Math.round(formattedPrize * 100) / 100;

          winnerData[
            `winner_${index + 1}`
          ] = `${currency} ${formattedPrize.toLocaleString()}`;
        });

        data.push({
          heading,
          category: this.selectedCategory,
          winners: winnerData,
        });
      });

      return data;
    },
    getLinks() {
      return this.eventData.links;
    },
  },

  mounted() {
    this.getCategories();
  },

  watch: {
    categories(v) {
      if (v.length > 0) {
        this.selectedCategory = v[0].value;
      }
    },
  },

  methods: {
    convertToSlug(text) {
      if (!text) return;
      return text
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
    },

    topThreeWinners(winners) {
      return {
        1: winners.winner_1,
        2: winners.winner_2,
        3: winners.winner_3,
      };
    },

    getCategories() {
      const categories = [];
      // Check if we have categories data
      if (
        this.eventData &&
        this.eventData.event_prize_money &&
        this.eventData.event_prize_money.categories
      ) {
        // Loop through category keys (1, 2, 3, etc.)
        Object.keys(this.eventData.event_prize_money.categories).forEach(
          (categoryKey) => {
            // Add each category as an option
            categories.push({
              value: categoryKey,
              label: `Category ${categoryKey}`,
            });
          }
        );
      }

      // If no categories were found, add a default
      if (categories.length === 0) {
        categories.push({
          value: "general",
          label: "General",
        });
      }

      this.categories = categories;
    },

    remainingWinners(winners) {
      // Create a copy of the winners object
      const copy = { ...winners };

      // Remove the first three winners and any non-winner properties
      delete copy.winner_1;
      delete copy.winner_2;
      delete copy.winner_3;

      return copy;
    },

    openChart(evt, cityName) {
      var i, tabContent, tablinks;
      tabContent = document.getElementsByClassName("tab-chartcontent");
      for (i = 0; i < tabContent.length; i++) {
        tabContent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks-btn");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(cityName).style.display = "block";
      evt.currentTarget.className += " active";
    },
  },
};
</script>

<style scoped>
.default-heading {
  font-size: 34px !important;
}

.nav-tabs .nav-item {
  width: 100%;
}

.prize-section .nav-tabs .nav-link {
  border-bottom: 1px solid wheat;
}

.prize-section .list-inline-item:not(:last-child) {
  margin-right: 60px;
}

.prize-section .stretch-list .list-inline-item:not(:last-child) {
  padding: 0 20px;
}
.block {
  display: block;
}
</style>
